// extracted by mini-css-extract-plugin
export default {"widget":"TextLinkWidget_widget__r6B-O"};